// Unpublished Work © 2026 Deere & Company.

import {useEffect, useState} from 'react';

export function useIsMobile(breakpoint: number) {
    const [isMobile, setIsMobile] = useState<boolean>(() => (window?.innerWidth ?? 801) <= breakpoint);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= breakpoint);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
}
